import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Components/Header.js';
import Footer from '../Components/Footer.js';
import { Box } from 'grommet/components/Box';
import { Paragraph } from 'grommet/components/Paragraph';
import { Text } from 'grommet/components/Text';
import { Heading } from 'grommet/components/Heading';
import { TextInput } from 'grommet/components/TextInput';
import { Anchor } from 'grommet/components/Anchor';
import { withRouter } from "react-router-dom";
import { OauthCtrl } from '../Controllers/IAM/OauthCtrl';
import { WelcomeCtrl } from '../Controllers/Account/WelcomeCtrl';
import { logout, isLandingAlertVisible, dismissLandingAlert/*, createCookie*/ } from '../Utils/Utility';
import ModalLoader from './../Components/ModalLoader';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { ApiConfig } from '../Config'



class Error extends React.Component {

    render() {

        return (
            <Box>
                <Text className='error'>{this.props.testo}</Text>
            </Box>
        );
    }
}



class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: '',
            password: '',
            codice: '',
            data: {},
            status: '',
            errorLogin: false,
            errorMsg: '',
            isRegistered: true,
            codesoc: "9285568127",
            codepos: "9522832757",
            codSocietario: '1',
            open: false,
            showTimeoutModal: false,
            codeStringToke: '',
            showLandingAlert: isLandingAlertVisible('dismissedLandingAlert')
        }
        this.setLogin = this.setLogin.bind(this);
        this.dismissLandingAlert = this.dismissLandingAlert.bind(this);

    }
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    setLogin(event) {
        if (event.target.id === 'user') {
            this.setState({
                user: event.target.value
            }, sessionStorage.setItem('user', event.target.value))
        } else {
            this.setState({
                password: event.target.value
            })
        }
    }

    dismissLandingAlert() {
        this.setState({ showLandingAlert: false });
        dismissLandingAlert('dismissedLandingAlert');
    }


    componentWillMount() {
        var string = window.location.search;

        var errore = '';
        var numAttempts = 0;
        var locked = false;
        var indexError = string.indexOf("PLUGIN_ERROR_RESPONSE");

        if (indexError > -1) {
            errore = string.slice(string.indexOf("PLUGIN_ERROR_RESPONSE") + "PLUGIN_ERROR_RESPONSE".length);
            var indInv = errore.indexOf("invalid");
            if (indInv > -1) {
                numAttempts = errore.slice(errore.indexOf("password+attempts") + "password+attempts".length).substring(1, 2);
            }
            var indLock = errore.indexOf("password+locked");
            if (indLock > -1) {
                locked = true;
            }
        }
        if ((indexError > -1) && (numAttempts > 0)) {
            if (numAttempts === "4") {
                this.setState({ errorLogin: true, errorMsg: "Password errata! Ultimo tentativo prima del blocco utenza!" })
            } else {
                this.setState({ errorLogin: true, errorMsg: "Username o password errati" })
            }
        } else if ((indexError > -1) && (locked === true)) {
            this.setState({ errorLogin: true, errorMsg: "Utenza bloccata. Contattare il servizio clienti backoffice" })
        } else if (indexError < 0) {
            var stringParam = string.substring(1, 5);
            var codeString = string.substring(6, string.length - 10);
            var jwtImpToke = string.substring(6, string.length);
            //var lb_dc_cookie = string.substring(string.length - 1);
            const { history } = this.props;
            /*this.state.codeStringToke = jwtImpToke;*/
            /*Creato setState per evitare di settare direttamente lo state*/
            this.setState({
                codeStringToke: jwtImpToke
            });
            const self = this;
            if (stringParam === 'code') {
                this.setState({ open: true });
                OauthCtrl(function (data) {
                    const uuidv1 = require('uuid/v1');
                    sessionStorage.setItem('ids', uuidv1());
                    sessionStorage.setItem('token', data.access_token);
                    /* insert welcome post login */
                    var token = sessionStorage.getItem('token');
                    var ids = sessionStorage.getItem('ids');

                    //self.setState({ open: true });
                    WelcomeCtrl(function (data, status) {
                        sessionStorage.setItem("dataWelcome", JSON.stringify(data));
                        sessionStorage.setItem("ebox", data.ebox);
                        sessionStorage.setItem("userType", data.userType);
                        if(data.passwordExpireDay < 1 && sessionStorage.getItem("userType") === 'PortaleAmex' ){
                            sessionStorage.setItem("navigable", false);
                            sessionStorage.setItem("path", '/ChangePassword');
                            history.push({
                                pathname: '/ChangePassword',
                                updatePassword: true
                            });
                        } else if (status === 206) {
                            sessionStorage.setItem("navigable", false);
                            sessionStorage.setItem("path", '/InsertTelephone');
                            history.push('/InsertTelephone');
                        } else if (status === 204) {
                            sessionStorage.setItem("navigable", false);
                            logout();
                            history.push({
                                pathname: '/login'
                            })
                            //alert('No result found')
                        } else if (status === 205) {
                            sessionStorage.setItem("navigable", false);
                            history.push({
                                pathname: '/AggiornaPassword',
                                updatePassword: true
                            });
                        } else {
                            sessionStorage.setItem("navigable", true);
                            sessionStorage.setItem("codSocietario", data.code);
                            sessionStorage.setItem("insegna", data.name);
                            sessionStorage.setItem("codesoc", data.codsoc);
                            sessionStorage.setItem("codepos", data.codPV);
                            sessionStorage.setItem("cellNumber", data.cellNumber);
                            history.push({
                                pathname: '/Home'
                            })
                        }
                    }, function (error) {
                        self.setState({ open: false });
                        if (error === 401 || error === 408) {
                            this.setState({
                                showTimeoutModal: true
                            })
                            // logout();
                            // this.props.history.push({
                            //     pathname: '/login'
                            // })
                        } else if (error === 500 || error === 404) {
                            logout();
                            history.push('/ErrorPage');
                        }
                    }, token, ids);
                    /* end welcome */

                }, function (error) {
                    self.setState({ 
                        open: false,
                        errorLogin: true,
                        errorMsg: "Username o password non corretti"
                    })
                    if (error === 401 || error === 408) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    } else if (error === 500 || error === 404) {
                        logout();
                        history.push('/ErrorPage');
                    }
                }, codeString)

            } else if (stringParam === 'p_er') {

                this.setState({ open:false, errorLogin: true, errorMsg: "Username o password non corretti" });

            } else if (stringParam === 'toke') {
                //createCookie("LB_DC_COOKIE", lb_dc_cookie)
                self.setState({ open: true });
                sessionStorage.setItem("navigable", true);
                sessionStorage.setItem("token", jwtImpToke);

                const uuidv1 = require('uuid/v1');
                sessionStorage.setItem('ids', uuidv1());

                /* insert welcome post login */
                var token = sessionStorage.getItem('token');
                var ids = sessionStorage.getItem('ids');

                WelcomeCtrl(function (data, status) {
                    sessionStorage.setItem("dataWelcome", JSON.stringify(data));
                    sessionStorage.setItem("ebox", data.ebox);
                    if(data.passwordExpireDay < 1 && sessionStorage.getItem("userType") === 'PortaleAmex' ){
                        sessionStorage.setItem("navigable", false);
                        sessionStorage.setItem("path", '/ChangePassword');
                        history.push({
                            pathname: '/ChangePassword',
                            updatePassword: true
                        });
                    } else if (status === 206) {
                        sessionStorage.setItem("navigable", false);
                        history.push('/InsertTelephone');
                    } else if (status === 204) {
                        sessionStorage.setItem("navigable", false);
                        history.push('/ErrorPage');
                        //alert('No result found')
                    } else if (status === 205) {
                        sessionStorage.setItem("navigable", false);
                        history.push({
                            pathname: '/AggiornaPassword',
                            updatePassword: true
                        });
                    } else {
                        sessionStorage.setItem("navigable", true);
                        sessionStorage.setItem("codSocietario", data.code);
                        sessionStorage.setItem("insegna", data.name);
                        sessionStorage.setItem("codesoc", data.codsoc);
                        sessionStorage.setItem("codepos", data.codPV);
                        sessionStorage.setItem("cellNumber", data.cellNumber);
                        history.push('/home');
                    }
                    self.setState({ open: false });
                }, function (error) {
                    self.setState({ open: false });
                    if (error === 401 || error === 408) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    } else if (error === 500 || error === 404) {
                        logout();
                        history.push('/ErrorPage');
                    }
                }, token, ids);

            } else if (sessionStorage.getItem('token') !== null) {

                history.push('/home');

            }
        }

    }

    render() {
        return (

            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <ModalLoader
                    openModal={this.state.open}
                    className="loaderClass"
                />
                <Box >
                    <Box >
                        <Header />
                        {this.state.showLandingAlert ? (
                            <div role="dialog" aria-modal="true" aria-labelledby="cookiesDialogTitle" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
                                <div style={{ background: '#ffffff', width: '100%', maxWidth: 560, borderRadius: 4, boxShadow: '0 8px 24px rgba(0,0,0,0.2)', overflow: 'hidden', fontFamily: "Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif" }}>
                                    <div id="cookiesDialogTitle" style={{ background: '#006FCF', color: '#fff', fontWeight: 600, padding: '10px 16px', textAlign: 'center' }}>
                                        Cookies di American Express
                                    </div>
                                    <div style={{ padding: '16px 16px 8px 16px', color: '#1b1b1b', lineHeight: 1.5, fontSize: 16 }}>
                                        American Express utilizza i cookie su questo sito web per garantirne il corretto funzionamento e la massima sicurezza e per fornire agli utenti i servizi richiesti (cookie essenziali). Per ulteriori informazioni sull'utilizzo dei cookie puo' consultare in qualsiasi momento la nostra 
                                        <a href="https://www.americanexpress.com/content/dam/amex/it/merchant/AXPNexiCookiesPolicyfinal.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#006FCF', textDecoration: 'underline', fontWeight: 600 }}>
                                            &quot;Cookie policy&quot;
                                        </a>
                                        .
                                    </div>

                                    <div style={{ padding: '0 16px 20px 16px', display: 'flex', justifyContent: 'center' }}>
                                        <button onClick={this.dismissLandingAlert} style={{ background: '#006FCF', color: '#fff', border: 'none', borderRadius: 2, padding: '10px 24px', cursor: 'pointer', fontWeight: 600 }}>
                                            Chiudi
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : ''}
                        <Box className='background' direction='row' justify='center' gap='small' >
                            <Box className='contentprelogin margin-content'>
                                <Paragraph className='logintext'>
                                    Scopri il nuovo Servizio Esercizi Online:
                                </Paragraph>
                                <Paragraph className='logintextp' style={{ color: '#ffffff' }}>
                                    il tuo business a portata di click,<br />24/7, in totale sicurezza
                                </Paragraph>  
                            </Box>
                            <Box className='contentprelogin'>
                                <Box direction='row' className='loginbox'>
                                    <Box className='header loginpanel'>
                                        <Box style={{ padding: '20px' }}>
                                            <Heading className='fixFont' level='1' style={{ marginBottom: '10px' }}>Login</Heading>
                                            <form style={{ textAlign: 'left' }} action={ApiConfig.url.LOGIN} method="post">
                                                <Text className='label'>USER ID</Text>
                                                <TextInput name='username' id='user' className='inputlogin' value={this.state.user} placeholder='User ID' onChange={this.setLogin} />
                                                <Text className='label'>PASSWORD</Text>
                                                <TextInput name='password' type='password' className='inputlogin' value={this.state.password} placeholder='Password' onChange={this.setLogin} />
                                                <TextInput name='successurl' type='hidden' className='inputlogin' value={ApiConfig.url.SUCCESS_URL} />
                                                <button type='submit' style={{ marginBottom: '10px', cursor: 'pointer', width: '100%' }} color='transparent' className='btnlogin' label='ACCEDI'>ACCEDI</button>
                                            </form>
                                            {this.state.errorLogin ? <Error testo={this.state.errorMsg} /> : ''}
                                            <Anchor id='linklogin' alignSelf='start' href='/RegistrationSelect'>Registrati ora</Anchor>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        <Footer />
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default Login = withRouter(Login)
